var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 12.1666V13.8333C1.33337 14.2753 1.50897 14.6992 1.82153 15.0118C2.13409 15.3243 2.55801 15.4999 3.00004 15.4999H13C13.4421 15.4999 13.866 15.3243 14.1786 15.0118C14.4911 14.6992 14.6667 14.2753 14.6667 13.8333V12.1666M3.83337 7.16659L8.00004 11.3333M8.00004 11.3333L12.1667 7.16659M8.00004 11.3333V1.33325",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6b7fa61078479b34546ebaee95a151ec.svg";
export { ForwardRef as ReactComponent };